import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data.user);
        // Clear hash, redirect to bookings
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/book", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login?error=google", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center text-zinc-500" data-testid="auth-callback">
      A concluir início de sessão…
    </div>
  );
}
